import React from 'react';
import { UserPlus } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';
import { Button } from '../Components/ui/button';
import { Input } from '../Components/ui/input';
import { Label } from '../Components/ui/label';

export default function AddInterviewer() {
  return (
    <div className="max-w-[800px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-3 rounded-lg">
            <UserPlus className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Add Interviewer</h1>
            <p className="text-sm text-gray-500">Add new interviewers to the system</p>
          </div>
        </div>
      </div>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <form className="space-y-4">
            <div>
              <Label>Full Name</Label>
              <Input placeholder="Enter interviewer name" />
            </div>
            <div>
              <Label>Email</Label>
              <Input type="email" placeholder="Enter email address" />
            </div>
            <div>
              <Label>Phone</Label>
              <Input placeholder="Enter phone number" />
            </div>
            <Button className="w-full">Add Interviewer</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}